import { NgModule } from '@angular/core';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyDatepickerModule } from '@ngx-formly/primeng/datepicker';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { FormlyAccordionTypeComponent } from './types/accordion/accordion-type.component';
import { FormlyCheckboxTypeComponent } from './types/checkbox/checkbox-type.component';
import { FormlyColorPickerTypeComponent } from './types/colorpicker/colorpicker-type.component';
import { CustomTemplateTypeComponent } from './types/custom-template/custom-template-type.component';
import { FormlyDatepickerTypeComponent } from './types/datepicker/datepicker-type.component';
import { FormlyDividerTypeComponent } from './types/divider/divider-type.component';
import { FormlyEditorTypeComponent } from './types/editor/editor-type.component';
import { FormlyGalleryTypeComponent } from './types/gallery/gallery-type.component';
import { FormlyMultiSelectLazyTypeComponent } from './types/multiselect-lazy/multiselect-lazy-type.component';
import { FormlyMultiselectTypeComponent } from './types/multiselect/multiselect-type.component';
import { ObjectTypeComponent } from './types/object/object-type.component';
import { FormlyPasswordTypeComponent } from './types/password/password-type.component';
import { FormlyPhoneNumberTypeComponent } from './types/phone-number/phone-number-type.component';
import { FormlyPriceConditionsTypeComponent } from './types/price-conditions/price-conditions-type.component';
import { FormlyRepeatTableTypeComponent } from './types/repeat-table/repeat-table-type.component';
import { FormlyRepeatTypeComponent } from './types/repeat/repeat-type.component';
import { FormlySelectLazyTypeComponent } from './types/select-lazy/select-lazy-type.component';
import { FormlySelectTypeComponent } from './types/select/select-type.component';
import { FormlyTabsRepeatTypeComponent } from './types/tabs-repeat/tabs-repeat-type.component';
import { FormlyTabsTypeComponent } from './types/tabs/tabs-type.component';
import { FormlyTextareaTypeComponent } from './types/textarea/textarea-type.component';
import { FormlyFieldButtonWrapperComponent } from './wrappers/button/filed-button-wrapper.component';
import { FormlyCollapseWrapperComponent } from './wrappers/collapse/collapse-wrapper.component';
import { FormlyFieldIconWrapperComponent } from './wrappers/field-icon/field-icon-wrapper.component';
import { FormlyFormFieldWrapperComponent } from './wrappers/form-field/form-field-wrapper.component';
import { FormlyPriceWrapperComponent } from './wrappers/price/price-wrapper.component';
@NgModule({
  imports: [
    FormlyPrimeNGModule,
    FormlyDatepickerModule,
    FormlyModule.forRoot({
      wrappers: [
        {
          name: 'form-field',
          component: FormlyFormFieldWrapperComponent,
        },
        {
          name: 'collapse',
          component: FormlyCollapseWrapperComponent,
        },
        {
          name: 'field-icon',
          component: FormlyFieldIconWrapperComponent,
        },
        {
          name: 'field-button',
          component: FormlyFieldButtonWrapperComponent,
        },
        {
          name: 'price',
          component: FormlyPriceWrapperComponent,
        },
      ],
      types: [
        {
          name: 'tabs',
          component: FormlyTabsTypeComponent,
        },
        {
          name: 'tabs-repeat',
          component: FormlyTabsRepeatTypeComponent,
        },
        {
          name: 'input',
          wrappers: ['form-field'],
        },
        {
          name: 'divider',
          component: FormlyDividerTypeComponent,
        },
        {
          name: 'multiselect',
          component: FormlyMultiselectTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'multiselect-lazy',
          component: FormlyMultiSelectLazyTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'select',
          component: FormlySelectTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'select-lazy',
          component: FormlySelectLazyTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'repeat',
          component: FormlyRepeatTypeComponent,
        },
        {
          name: 'array',
          component: FormlyRepeatTypeComponent,
        },
        {
          name: 'repeat-table',
          component: FormlyRepeatTableTypeComponent,
        },
        {
          name: 'accordion',
          component: FormlyAccordionTypeComponent,
        },
        {
          name: 'editor',
          component: FormlyEditorTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'phone-number',
          component: FormlyPhoneNumberTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'password',
          component: FormlyPasswordTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'gallery',
          component: FormlyGalleryTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'datepicker',
          component: FormlyDatepickerTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'price-conditions',
          component: FormlyPriceConditionsTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'checkbox',
          component: FormlyCheckboxTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'colorpicker',
          component: FormlyColorPickerTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'custom-template',
          component: CustomTemplateTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'textarea',
          component: FormlyTextareaTypeComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'object',
          component: ObjectTypeComponent,
        },
      ],
      validationMessages: [
        {
          name: 'required',
          message: 'Toto pole je povinné',
        },
        {
          name: 'min',
          message: (error, field: FormlyFieldConfig) => {
            const min = error.min;

            if (min !== undefined) {
              return `Hodnota musí byť minimálne ${min}`;
            }

            return `Hodnota je príliš nízka`;
          },
        },
        {
          name: 'max',
          message: (error, field: FormlyFieldConfig) => {
            const max = error.max;

            if (max !== undefined) {
              return `Hodnota musí byť maximálne ${max}`;
            }

            return `Hodnota je příliš vysoká`;
          },
        },
      ],
    }),
    DynamicFormComponent,
  ],
  exports: [],
})
export class DynamicFormModule {}
